import { useNavigate } from 'react-router-dom';
import PublicLegalPage from '@/components/PublicLegalPage';
import { COMMUNITY_GUIDELINES_PAGE_CONTENT, PUBLIC_CORE_LINK_LABELS } from '../../ui-foundation';

export default function CodeOfConductPage() {
  const navigate = useNavigate();

  return (
    <PublicLegalPage
      title={COMMUNITY_GUIDELINES_PAGE_CONTENT.title}
      subtitle={COMMUNITY_GUIDELINES_PAGE_CONTENT.subtitle}
      introBody={COMMUNITY_GUIDELINES_PAGE_CONTENT.introBody}
      sections={COMMUNITY_GUIDELINES_PAGE_CONTENT.sections}
      actions={[
        {
          label: 'Back to community',
          onPress: () => navigate('/community?view=channels'),
          tone: 'outline',
        },
        { label: PUBLIC_CORE_LINK_LABELS.privacy, onPress: () => navigate('/privacy'), tone: 'outline' },
        { label: PUBLIC_CORE_LINK_LABELS.terms, onPress: () => navigate('/terms'), tone: 'outline' },
        { label: PUBLIC_CORE_LINK_LABELS.contactSupport, onPress: () => navigate('/contact-complaints'), tone: 'outline' },
      ]}
    />
  );
}
